<script lang="ts" setup>
import type { IProps } from './banner.types'

withDefaults(defineProps<IProps>(), {
  color: 'white',
  background: 'transparent',
})

</script>

<template>
  <UiSection
    :color="background"
    :style="bgImage ? { backgroundImage: `url(${bgImage})` } : {}"
  >
    <div class="banner">
      <h4
        v-if="heading"
        :class="[
          'banner__heading',
          `banner__heading--${color}`
        ]"
        v-html="heading"
      />

      <h3
        :class="[
          'banner__text',
          `banner__text--${color}`
        ]"
        v-html="text"
      />
      
      <UiButton
        v-if="button && button.text"
        class="banner__button"
        variant="primary"
        :to="button.to"
        :target="button.target || '_self'"
      >
        <span
          v-if="button.icon"
          class="button__icon"
        >
          <img
            class="button__img"
            width="24px"
            height="24px"
            alt=""
            :src="button.icon"
          >
        </span>

        {{ button.text }}
      </UiButton>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
  .section {
    display: flex;
    align-items: center;
    min-height: 53rem;
    background-repeat: no-repeat;
    background-position-y: 35%;
    background-size: 100%;

    @include atXS {
      min-height: auto;
    }

    @include atM {
      min-height: 53rem;
      padding: 4.8rem 8rem 8rem 8rem;
      background-position-x: 100%;
      background-position-y: 100%;
      background-size: 45%;
    }

    @include atXL {
      min-height: 69.4rem;
      padding: 10rem;
    }
  }

  .banner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    &__heading {
      @include body-1-medium;
      color:$text-400;

      &--white {
        color:$light-blue-400;
      }
    }

    &__text {
      margin-bottom: 4.6rem;
      font-weight: 500;
      font-size: 2.8rem;
      line-height: 3.6rem;

      &--white {
        color: $white;
         :deep(i) {
            color: $light-blue-400;
          }
      }

      @include atM {
        width: 65%;
        margin-top: 6.4rem;
        font-size: 4.8rem;
        line-height: 5.6rem;
      }

      @include atXL {
        font-size: 5.6rem;
        line-height: 6.8rem;
      }
    }

    .button {
      &__icon {
        margin-right: 1.6rem;
      }

      &__img {
        width: 2.4rem;
        height: 2.4rem;
      }
    }
  }
</style>
